<template>
  <div class="flex flex-column gap-2" data-testid="facility-administrator-contact">
    <a-skeleton
      v-if="loading"
      active
      :title="false"
      :paragraph="{ rows: 2, width: ['60%', '40%'] }"
      data-testid="facility-administrator-contact-skeleton"
    />
    <div v-else-if="error" class="flex flex-column gap-2" data-testid="facility-administrator-contact-error">
      <p class="m-0">Administrator contact couldn’t be loaded.</p>
      <a-button size="small" class="w-fit" @click="loadContact" data-testid="facility-administrator-contact-retry">
        Retry
      </a-button>
    </div>
    <p
      v-else-if="!contact || (!contact.phone && !contact.email)"
      class="m-0"
      data-testid="facility-administrator-contact-unavailable"
    >
      No facility administrator contact is listed for this associate.
    </p>
    <a-descriptions v-else :column="1" size="small" :colon="false" data-testid="facility-administrator-contact-card">
      <a-descriptions-item label="Name">{{ contact.display_name }}</a-descriptions-item>

      <a-descriptions-item v-if="contact.role" label="Role">{{ contact.role }}</a-descriptions-item>

      <a-descriptions-item v-if="contact.phone" label="Phone">
        <a :href="`tel:${contact.phone}`">{{ contact.phone }}</a>
      </a-descriptions-item>

      <a-descriptions-item v-if="contact.email" label="Email">
        <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { Skeleton, Descriptions, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-skeleton': Skeleton,
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item
  },
  props: {
    associateId: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      error: false,
      contact: undefined
    }
  },
  watch: {
    associateId: {
      handler() {
        this.loadContact()
      },
      immediate: true
    }
  },
  methods: {
    ...profileActions(['fetchResponsibleContacts']),
    async loadContact() {
      this.loading = true
      this.error = false
      this.contact = undefined
      try {
        const administrators = await this.fetchResponsibleContacts({ associateId: this.associateId })
        this.contact = administrators[0] ?? undefined
      } catch (error) {
        this.error = true
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    },
    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    }
  }
}
</script>
